import React from 'react';

const PreloaderIcon = () => {
  return (
    <svg
      version={1.1}
      xmlns={'http://www.w3.org/2000/svg'}
      xmlnsXlink={'http://www.w3.org/1999/xlink'}
      x={0}
      y={0}
      viewBox={'0 0 453 281'}
      // style="enable-background:new 0 0 453 281;"
      xmlSpace={'preserve'}
    >
      <path
        d={'M366.4,287.3l-82.2-136.9c0,0,0,0-37.2,61.3c-7.4,11-33.8,47.4-80.4,57.3C106.2,281.9,29,246.5,11.9,172.4S48.7,32.7,108.6,17.7c46.2-11.5,85.9,9.6,97.4,16.3'}
      />
      <path
        d={'M393.2,287.3l-109-181.4c0,0,0,0-56.7,93.7c-30.8,49.3-96.8,64.5-146.1,33.7S16.9,136.5,47.7,87.2s96.8-64.5,146.1-33.7'}
      />
      <path
        d={'M419.9,287.3l-135.8-226c0,0,0,0-76.9,127.3c-24.8,38.2-76.7,49.2-114.9,24.4S43.1,136.4,67.9,98.2s76.7-49.2,114.9-24.4'}
      />
      <path
        d={'M446.7,287.3L284.2,16.7c0,0,0,0-96.2,159.4c-18,27.7-55.5,35.6-83.2,17.7s-35.6-55.5-17.7-83.2S142.7,75,170.3,93'}
      />
    </svg>
  );
};

export default PreloaderIcon;